import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getTasks = (query) => axios.get(toQueryString("api/v1/task-managements?", query, true));

const getById = (id, query) => axios.get(toQueryString(`/api/v1/task-managements/${id}?`, query));

const getSimpleTaskList = (query) => axios.get(toQueryString("api/v1/daily-tasks/simple?", query));

const addTask = (task) => axios.post("api/v1/task-managements", task);

const updateTask = (id, task) =>
  axios.put(`api/v1/task-managements/${id}`, task);

const deleteTask = (id) => axios.delete(`api/v1/task-managements/${id}`);

const deleteTasks = (ids) =>
  axios.delete("api/v1/task-managements/bulk", {
    data: { ids },
  });

const getTaskById = (id) => axios.get(`api/v1/task-managements/${id}`);

const publish = (id, params) => axios.put(`/api/v1/task-managements/${id}/publish`, params);

const discard = (id, params) => axios.put(`/api/v1/task-managements/${id}/discard`, params);

const getActiveTasks = (id, params) => axios.get(`/api/v1/task-managements/active`, params);

const getBaselines = (id, params) => axios.get(`/api/v1/task-managements/baselines`, params);

const toggleStatus = (id, params) => axios.put(`/api/v1/task-managements/${id}/toggle-status`, params);

const duplicateTask = (id) => axios.post(`/api/v1/task-managements/${id}/duplicate`);

// Subject task assignment endpoints (admin manually attaches DailyTasks to a
// specific subject for a specific local date, see plan page in subjects-mgmt).
const assignSubjectTask = (subjectId, payload) =>
  axios.post(`/api/v1/task-managements/subject/${subjectId}/assign`, payload);

const updateAssignedSubjectTask = (subjectId, taskId, payload) =>
  axios.put(`/api/v1/task-managements/subject/${subjectId}/assigned-tasks/${taskId}`, payload);

const removeAssignedSubjectTask = (subjectId, taskId) =>
  axios.delete(`/api/v1/task-managements/subject/${subjectId}/assigned-tasks/${taskId}`);

const getUpcomingAssignments = (subjectId) =>
  axios.get(`/api/v1/task-managements/subject/${subjectId}/upcoming-assignments`);

const ApiTaskManagement = {
  getTasks,
  addTask,
  updateTask,
  deleteTask,
  getSimpleTaskList,
  getTaskById,
  publish,
  discard,
  getActiveTasks,
  toggleStatus,
  getBaselines,
  getById,
  deleteTasks,
  duplicateTask,
  assignSubjectTask,
  updateAssignedSubjectTask,
  removeAssignedSubjectTask,
  getUpcomingAssignments,
};

export default ApiTaskManagement;
